import { StorageType, StorageUtil } from 'src/app/utils';

export class UserAuthDetails {
  public static readonly USER_LOGIN_STORAGE_KEY = 'loginuser';
  public static readonly USER_LOGIN_AUTH_STORAGE_KEY = 'userToken';
  public static getUserLoggedInId(): string {
    return (
      StorageUtil.getDataFromStorage(
        UserAuthDetails.USER_LOGIN_STORAGE_KEY,
        StorageType.LOCAL_STORAGE
      ) || ''
    );
  }

  public static getUserAuthToken(): string {
    return (
      StorageUtil.getDataFromStorage(
        UserAuthDetails.USER_LOGIN_AUTH_STORAGE_KEY,
        StorageType.LOCAL_STORAGE
      ) || ''
    );
  }
}
